import React, { forwardRef, useEffect, useState } from 'react';
import {
	NumberFormattinginLocale,
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import { ProductCardWrapper } from './ProductCard.styled';
type Props = {
	media_link: string;
	title: any;
	currency: string;
	price: string | number;
	className?: string;
	loading?: boolean;
	index?: number;
	onClick?: Function;
	chatMessageIndex?: number;
	productId?: string;
	hideContent?: boolean;
	details?: any;
	noHover?: boolean;
	aspectRatio?: string;
	updateCart?;
	sale_price: string | number;
};

const ProductCard = forwardRef(
	(
		{
			media_link,
			title,
			currency,
			price,
			className,
			loading,
			index,
			onClick,
			chatMessageIndex,
			productId,
			hideContent,
			details,
			noHover,
			aspectRatio,
			updateCart,
			sale_price,
		}: Props,
		ref
	) => {
		const [wishlisted, setWishListed] = useState(false);
		useEffect(() => {
			let fav =
				loadStateSession('FF-favlist') &&
				loadStateSession('FF-favlist').filter(
					(product) => (product.product_id || product.productId) === productId
				);
			if (fav && fav.length > 0) {
				setWishListed(true);
			} else {
				setWishListed(false);
			}
		}, []);

		useEffect(() => {
			if (productId === updateCart) {
				setWishListed(false);
			}
		}, [updateCart]);

		return (
			<ProductCardWrapper
				ref={ref}
				aspectRatio={aspectRatio}
				className={className}
				animationIndex={index}
				noHover={noHover}
				onClick={() => onClick && onClick(chatMessageIndex, productId)}
				title={title}
				href={details && details.product_url ? details.product_url : '#'}
				target='_blank'
				rel='noopener noreferrer'>
				{loading === true ? (
					<div className='image-placeholder'>
						<div className={`gradient-animation-diagonal `}>
							<p className={`${loading === true ? 'flashing-text' : ''}`}>
								{title}
							</p>
						</div>
					</div>
				) : (
					<img src={media_link} alt={title} loading='lazy' />
				)}
				<div className={`content ${hideContent ? 'hide' : ''}`}>
					<div className={`title ${loading === true ? 'flashing-text' : ''}`}>
						{title}
					</div>
					{Number(price) ? (
						<div className='price-holder'>
							{Number(price) > Number(sale_price) && (
								<div className='ff-chatbot-body2 sale-price'>
									{getCurrencySymbol(currency)}
									{NumberFormattinginLocale(Math.floor(Number(sale_price)))}
								</div>
							)}
							{/*add this in class of price class  */}
							{price && (
								<div
									className={`ff-chatbot-body2 price 
										${
											sale_price
												? Number(price) > Number(sale_price)
													? 'line-through'
													: 'restore-color'
												: 'restore-color'
										}
									`}>
									{getCurrencySymbol(currency)}
									{NumberFormattinginLocale(Math.floor(Number(price)))}
								</div>
							)}
							{Number(price) > Number(sale_price) ? (
								<div className='ff-chatbot-caption discount '>
									<span>
										{Number(
											((Number(price) - Number(sale_price)) / Number(price)) *
												100
										).toFixed(0)}
										%
									</span>
									<span>OFF</span>
								</div>
							) : null}
						</div>
					) : null}

					{/* <h5>{product.brand}</h5> */}
				</div>
				{/* {loadStateSession('clientDetails').wishlistInCard ? (
					<div
						className='wishlist'
						onClick={(e) => {
							e.stopPropagation();
							let array =
								loadStateSession('FF-favlist') &&
									loadStateSession('FF-favlist').length > 0
									? loadStateSession('FF-favlist')
									: [];
							if (wishlisted) {
								setWishListed(false);
								const newProductDetails = loadStateSession('FF-favlist').filter(
									(product) =>
										(product.product_id || product.productId) !== productId
								);
								saveStateSession('FF-favlist', newProductDetails);
							} else {
								setWishListed(true);
								array.push(details);
								saveStateSession('FF-favlist', array);
							}
						}}
					>
						{wishlisted ? (
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
							>
								<path
									fillRule='evenodd'
									clipRule='evenodd'
									d='M11.0437 1.99199C11.5173 1.98948 11.9868 2.0803 12.4253 2.25927C12.8638 2.43824 13.2628 2.70186 13.5994 3.03505C13.936 3.36825 14.2037 3.76451 14.3872 4.20118C14.5706 4.63785 14.6662 5.10639 14.6686 5.58002L14.6686 5.58284C14.6686 6.33811 14.517 7.57465 13.6693 9.04534C12.8235 10.5128 11.3028 12.1821 8.61282 13.8356L8.61075 13.8368C8.42674 13.9489 8.21544 14.0081 7.99999 14.0081C7.78454 14.0081 7.57324 13.9489 7.38922 13.8368L7.38711 13.8355C4.69779 12.1821 3.17705 10.5131 2.33112 9.04583C1.48329 7.57531 1.33142 6.33877 1.33142 5.58284V5.58002C1.33375 5.1065 1.42932 4.63808 1.61268 4.2015C1.79604 3.76491 2.0636 3.36872 2.40007 3.03554C2.73655 2.70236 3.13536 2.43871 3.57373 2.25966C4.01209 2.08061 4.48144 1.98966 4.95496 1.99199C4.98162 1.99212 5.00825 1.99411 5.03464 1.99795C5.71374 2.09661 6.36646 2.32922 6.95489 2.68228C7.33826 2.9123 7.68936 3.19046 7.99997 3.50927C8.31041 3.19059 8.66133 2.91252 9.04449 2.68253C9.63269 2.32948 10.2852 2.09679 10.964 1.99797C10.9904 1.99413 11.017 1.99214 11.0437 1.99199Z'
									fill='#F831BC'
								/>
							</svg>
						) : (
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
							>
								<g id='favourite icon'>
									<path
										id='heart icon'
										fillRule='evenodd'
										clipRule='evenodd'
										d='M11.0428 2.00005C11.5163 1.99754 11.9856 2.08824 12.424 2.26697C12.8624 2.4457 13.2613 2.70896 13.5978 3.04171C13.9343 3.37446 14.2019 3.77018 14.3853 4.20626C14.5687 4.64235 14.6643 5.11025 14.6666 5.58325L14.6667 5.58606C14.6666 6.34031 14.5151 7.57518 13.6677 9.04389C12.8221 10.5093 11.3018 12.1764 8.61263 13.8277L8.61056 13.8289C8.4266 13.9408 8.21536 14 7.99997 14C7.78458 14 7.57334 13.9408 7.38938 13.8289L7.38727 13.8276C4.69871 12.1764 3.1784 10.5096 2.33271 9.04439C1.48513 7.57585 1.3333 6.34097 1.3333 5.58606V5.58325L1.3333 5.58325C1.33563 5.11037 1.43117 4.64257 1.61448 4.20658C1.79779 3.77058 2.06527 3.37492 2.40165 3.04219C2.73803 2.70946 3.13672 2.44617 3.57497 2.26736C4.01321 2.08855 4.48242 1.99772 4.9558 2.00005C4.98246 2.00018 5.00908 2.00217 5.03547 2.006C5.71437 2.10452 6.3669 2.33682 6.95517 2.6894C7.33843 2.91912 7.68943 3.1969 7.99995 3.51528C8.31031 3.19703 8.66112 2.91933 9.04417 2.68966C9.63221 2.33708 10.2845 2.10471 10.9632 2.00602C10.9895 2.00219 11.0161 2.00019 11.0428 2.00005ZM11.0881 3.14657C10.5744 3.22658 10.0808 3.40517 9.6348 3.67261C9.17709 3.94705 8.77852 4.30958 8.46222 4.73915C8.35409 4.886 8.18248 4.97272 7.99999 4.97272C7.81749 4.97273 7.64588 4.88602 7.53774 4.73917C7.22133 4.30949 6.8226 3.9469 6.36471 3.67246C5.9185 3.40501 5.42477 3.22648 4.91085 3.14658C4.60153 3.15 4.29551 3.21173 4.00892 3.32867C3.7102 3.45055 3.43844 3.63001 3.20915 3.85681C2.97986 4.08361 2.79754 4.35331 2.67259 4.6505C2.54782 4.94726 2.48271 5.26564 2.48094 5.5875C2.48113 6.17644 2.59654 7.20625 3.32695 8.47177C4.05969 9.74134 5.42932 11.2791 7.98681 12.8501C7.99081 12.8524 7.99535 12.8536 7.99997 12.8536C8.00461 12.8536 8.00916 12.8524 8.01317 12.8501C10.5712 11.2791 11.9408 9.74108 12.6734 8.4714C13.4036 7.20582 13.5188 6.17602 13.519 5.58756C13.5172 5.2656 13.4521 4.94712 13.3273 4.65028C13.2023 4.35303 13.0198 4.0833 12.7905 3.85648C12.5611 3.62967 12.2892 3.45023 11.9904 3.3284C11.7037 3.21151 11.3975 3.14986 11.0881 3.14657Z'
										fill='var(--primary-color-ff-primary900)'
									/>
								</g>
							</svg>
						)}
					</div>
				) : null} */}
			</ProductCardWrapper>
		);
	}
);

export default ProductCard;
